module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="main-menu-wrap">\n	<a href="javascript:void(0)" class="ion-android-menu main-menu-button hidden-mobile js-open-main-menu"></a>\n	<div class="main-menu js-main-menu">\n		<p>\n			<a href="javascript:void(0)" class="ion-android-close js-close-menu"></a>\n		</p>\n		<a href="" title="NRL Tipping" class="logo">\n			<picture>\n				<source srcset="/assets/images/logo_menu.webp" type="image/webp">\n				<img src="/assets/images/logo_menu.png" alt="NRL Tipping">\n			</picture>\n		</a>\n		<div class="menu-items-wrapper">\n\n			<ul class="menu-items">\n				';
 _.each(menu_items, function(item) { 
__p+='\n					<li>\n						<a href="'+
((__t=( item.path ))==null?'':_.escape(__t))+
'">'+
((__t=( item.name ))==null?'':_.escape(__t))+
'</a>\n					</li>\n				';
 }); 
__p+='\n			</ul>\n\n			';
 if( external_menu_items && external_menu_items.length !== 0 ) { 
__p+='\n				<ul class="additional-menu">\n					';
 _.each(external_menu_items, function(item){ 
__p+='\n						<li>\n							<a href="'+
((__t=( item.path ))==null?'':_.escape(__t))+
'" target="_blank">'+
((__t=( item.name ))==null?'':_.escape(__t))+
'</a>\n						</li>\n					';
 }); 
__p+='\n				</ul>\n			';
 } 
__p+='\n			<div class="log-out-block">\n				<a href="javascript:void(0)" class="js-log-out">Log Out</a>\n			</div>\n		</div>\n	</div>\n</div>\n\n';
 if(current_menu) { 
__p+='\n	<div class="secondary-menu '+
((__t=( (current_menu.top_breadcrumb) ? 'breadcrumb-items' : '' ))==null?'':_.escape(__t))+
'">\n		';
 if(!show_extra_menu) { 
__p+='\n			<ul>\n\n				';
 if(current_menu.top_breadcrumb) { 
__p+='\n					<li class="breadcrumb">\n						<a href="'+
((__t=( current_menu.top_breadcrumb.path ))==null?'':_.escape(__t))+
'">'+
((__t=( current_menu.top_breadcrumb.name ))==null?'':_.escape(__t))+
'</a>\n					</li>\n				';
 } 
__p+='\n\n				';
 _.each(current_menu.sub_menus_list, function(item){ 
__p+='\n                    <li class="'+
((__t=( item.class || '' ))==null?'':_.escape(__t))+
'">\n						';
 if(is_last_round_started && item.check_for_end_season) { 
__p+='\n							<a href="javascript:void(0)" class="'+
((__t=( (item.active)?'active':'' ))==null?'':_.escape(__t))+
' js-show-message" data-message="'+
((__t=( item.message ))==null?'':_.escape(__t))+
'">\n								'+
((__t=( item.name ))==null?'':_.escape(__t))+
'\n							</a>\n						';
 } else { 
__p+='\n                        <a href="'+
((__t=( item.path ))==null?'':_.escape(__t))+
'" class="'+
((__t=( (item.active)?'active':'' ))==null?'':_.escape(__t))+
'">\n                            '+
((__t=( item.name ))==null?'':_.escape(__t))+
'\n                        </a>\n						';
 } 
__p+='\n                    </li>\n				';
 }); 
__p+='\n			</ul>\n	</div>\n';
 } else { 
__p+='\n	<div class="extra-menu">\n		<ul>\n			';
 if(current_menu.breadcrumb) { 
__p+='\n				<li class="breadcrumb">\n					<a href="'+
((__t=( current_menu.breadcrumb.path ))==null?'':_.escape(__t))+
'">'+
((__t=( current_menu.breadcrumb.name ))==null?'':_.escape(__t))+
'</a>\n				</li>\n			';
 } 
__p+='\n			';
 _.each(current_menu.extra_menus_list, function(item){ 
__p+='\n				';
 if(item.is_visible) { 
__p+='\n					<li class="'+
((__t=( item.class || '' ))==null?'':_.escape(__t))+
'">\n						<a href="'+
((__t=( item.path ))==null?'':_.escape(__t))+
'" class="'+
((__t=( (item.active)?'active':'' ))==null?'':_.escape(__t))+
'">\n							'+
((__t=( item.name ))==null?'':_.escape(__t))+
'\n						</a>\n					</li>\n				';
 } 
__p+='\n			';
 }); 
__p+='\n		</ul>\n	</div>\n	';
 } 
__p+='\n';
 } 
__p+='';
}
return __p;
};
